import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import { userIsAdminOfAnyApplication } from '../../permissions';
import Gravatar from './Gravatar';
import DropdownMenu, { DropdownMenuItem } from './DropdownMenu';

const alliDomain = process.env.ALLI_DOMAIN; // eslint-disable-line no-undef

export default function Avatar({ currentUser, currentClient, navigateToUrl }) {
    const [show, setShow] = useState(false);

    const onItemClick = useCallback(
        event => {
            setShow(false);
            navigateToUrl(event);
        },
        [setShow, navigateToUrl],
    );

    const isAdmin = userIsAdminOfAnyApplication(currentUser);

    return (
        <div className="relative">
            <button
                className={classNames(
                    'w-8 h-8 flex rounded-full text-white focus:outline-none focus-visible:ring-2 relative items-center place-content-center',
                )}
                onClick={() => setShow(!show)}
            >
                <div className="flex items-center text-sm font-normal leading-5 group rounded-full">
                    <Gravatar
                        email={currentUser.email}
                        defaultStyle="404"
                        show={show}
                        fallback={
                            <UserInitial from={currentUser.email} show={show} />
                        }
                    />
                </div>
            </button>
            <DropdownMenu
                show={show}
                onClick={() => {
                    setShow(false);
                }}
            >
                <DropdownMenuItem onClick={onItemClick} to="/me">
                    Profile
                </DropdownMenuItem>
                {currentClient && (
                    <DropdownMenuItem
                        onClick={onItemClick}
                        to={`/client/${currentClient.slug}/manage`}
                    >
                        Manage Client
                    </DropdownMenuItem>
                )}
                {isAdmin ? (
                    <DropdownMenuItem
                        onClick={onItemClick}
                        to="/admin?state=created&state=pending&state=enabled"
                    >
                        Admin
                    </DropdownMenuItem>
                ) : null}
                <DropdownMenuItem
                    to={`https://login.${alliDomain}/logout`}
                    className="text-red-400 hover:text-red-500"
                >
                    Sign Out
                </DropdownMenuItem>
            </DropdownMenu>
        </div>
    );
}

function UserInitial({ from, show }) {
    return (
        <div
            className={classNames(
                'w-8 h-8 flex rounded-full text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 focus:outline-none focus-visible:ring-2 relative items-center place-content-center',
                {
                    'bg-blue-800': show,
                },
            )}
        >
            {from.split('').shift().toUpperCase()}
        </div>
    );
}
